export type ErrorReference = {
  nodeId: string;
  message: string;
};

enum EnumNodeType {
  INITIAL = 'initial',
  MESSAGE = 'message',
  KEYWORDS = 'keywords',
  FILTER = 'filter',
  TOOL = 'tool',
  LOOP = 'loop',
}

export default EnumNodeType;
